import { Stack } from "@mui/material";
import { useTranslation } from "react-i18next";

import type { UseTransientScenariosReturn } from "../hooks/useTransientScenarios";

import { ScenarioDefinitionRow } from "./ScenarioDefinitionRow";

type TransientScenarioStepProps = {
  scenariosState: UseTransientScenariosReturn;
};

export const TransientScenarioStep = ({ scenariosState }: TransientScenarioStepProps) => {
  const { t } = useTranslation();
  const { isLoading, scenarios } = scenariosState;

  if (isLoading) {
    return <p className="font-ds-body-regular-md text-lds-foreground-muted">{t("general.loadingDataPleaseWait")}</p>;
  }
  if (scenarios.length === 0) {
    return (
      <p className="font-ds-body-regular-md text-lds-foreground-muted">{t("Execution.transient.scenario.emptyState")}</p>
    );
  }

  return (
    <Stack className="w-full flex-col gap-6">
      {scenarios.map((scenario) => (
        <ScenarioDefinitionRow key={scenario.id} scenario={scenario} scenariosState={scenariosState} />
      ))}
    </Stack>
  );
};
